import * as React from 'react';
import * as Recaptcha from 'react-recaptcha';
import { Link } from 'react-router-dom';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { scrollToTop } from '../core/index';
import { getAjaxhelper } from '../utils/CoreAjaxHelper';
import { requestToken } from '../utils/request-token';
export interface CancelationsRequestProps extends BaseComponentProps {
    lang: string;
    history?: History;
}

export interface CancelationsRequestState extends BaseComponentState {
    cancelToken?: string;
    recapchaColback?: string;
    status: 'REQUEST' | 'ERROR' | 'SUCESS';
    message: string;
}

export class CancelationsRequest extends BaseComponent<CancelationsRequestProps, CancelationsRequestState> {

    constructor(props: CancelationsRequestProps) {
        super(props);
        this.state = {
            cancelToken: '',
            status: 'REQUEST',
            message: ''
        };
    }

    componentDidMount() {
        scrollToTop();
        this.getToken();
    }
    getToken: () => any = () => {
        requestToken().then(d => {
            this.setState({ cancelToken: d });
        }).catch(exc => {
            console.log(exc);
        });
    }
    onFormSubmit: (event: any) => any = (event: any) => {
        event.preventDefault();
        let idBooking = event.target['bookingId'].value;
        let email = event.target['email'].value;
        let message = event.target['message'].value;
        // let cancelToken = event.target['cancelToken'].value;
        getAjaxhelper().put('/dynamics/booking/submit-cancel-booking.svc', {
            token: this.state.cancelToken,
            email: email,
            reffNo: idBooking,
            remark: message
        }).then(d => { 
            this.setState({status: 'SUCESS'});
        }).catch(exc => {
           this.setState({message: exc.message, status: 'ERROR'}, this.getToken());
        }); 
    }

    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        let colback: any;
        let frm2 = <span />;
        let frm: any = (
            <form
                onSubmit={this.onFormSubmit}
                name="cancelForm"
                id="cancelForm"
            >
                <div className="row" style={{ marginBottom: 15 }}>
                    <div className="form-group">
                        <div className="col-md-6">
                            <label> Booking Id <span className="symbol required" /> </label>
                            <input type="text" placeholder="Please enter your Booking Id." className="form-control" name="bookingId" id="bookingId1" required={true} />
                        </div>
                    </div>
                </div>
                <div className="row" style={{ marginBottom: 15 }}>
                    <div className="form-group">
                        <div className="col-md-6">
                            <label> Your email address <span className="symbol required" /> </label>
                            <input type="email" placeholder="Please enter your email address." className="form-control" name="email" id="email" required={true} />
                        </div>
                    </div>
                </div>
                <div className="row" style={{ marginBottom: 15 }}>
                    <div className="form-group">
                        <div className="col-md-12">
                            <label> Reason <span className="symbol required" /> </label>
                            <textarea placeholder="Please enter your message." className="form-control" name="message" id="message" required={true} />
                            <input type="hidden" value={this.state.cancelToken} id="cancelToken" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Recaptcha
                            sitekey="6LfBgyUTAAAAAKAv2C1Za0Jgpcp96rH2SjxfGl8i"
                            render="explicit"
                            verifyCallback={data => this.setState({ recapchaColback: data })}
                            onloadCallback={colback}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <button className="btn btn-primary" type="sumbit">
                            <span>Send Message</span>
                        </button>
                    </div>
                </div>
            </form>
        );
        if (this.state.status === 'ERROR') {
            frm2 = (
                <div className="panel panel-red">
                    <div className="panel-heading">
                        <h4 className="panel-title">Request Cancalation Unseccess</h4>

                    </div>
                    <div className="panel-body">
                        <p>
                            {this.state.message}
						</p>
                    </div>
                </div>
            );
        } else if (this.state.status === 'SUCESS') {
            frm = (
                <div className="panel panel-primary">
                    <div className="panel-heading">
                        <h4 className="panel-title">Request Cancalation Successfuly</h4> 
                    </div>
                    <div className="panel-body">
                        <p>
                            We understand that sometimes, circumstances change. If you need to cancel your booking, please get in touch with us as straight away using the form below. You’ll then receive further information regarding the process of your cancellation request. 
						</p>
                    </div>
                </div>
            );
        }
        return (
            <div>

                <h3 style={{ borderBottom: '1px solid #eee' }}>Booking Cancelation Process</h3>
                <p>
                We understand that sometimes, circumstances change. If you need to cancel your booking, please get in touch with us as straight away using the form below. You’ll then receive further information regarding the process of your cancellation request. 
                </p>
                
                <h3 style={{ borderBottom: '1px solid #eee' }}>Booking Cancelation Term &#38; Conditions </h3>
                <p>
                 Cancellation Terms and Conditions vary for different bookings. These are displayed on the Hotel Voucher 
                 that was issued during your hotel booking process and can also be seen as part of our <Link to="https://www.balihotelsandmore.com/terms-of-use" >terms and conditions. </Link>
                </p> 
                <h3 style={{ borderBottom: '1px solid #eee' }}>Booking Cancelation Form</h3>
                {frm2}
                {frm}
            </div>
        );
    }
}  
/*

<ul>
                    <li>Submit booking form, <a href='#cancelForm'>Click Here For booking form</a></li>
                    <li>Verivication by admin for your booking</li>
                    <li>Admin send email for your verification (1x24 hours)</li>
                    <li>You need click link verivication on email </li>
                    <li>Server replay to your booking status </li>
                </ul>

*/


// WEBPACK FOOTER //
// ./src/static-content/CancelationsRequest.tsx